import { getAllFormSubmissions, getAssessmentFormKeys, requestAdministeredSubmission, RequestAdministeredSubmissionParams } from '@uplift/api';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { CalendarDateService } from '@uplift/services';
import { AssessmentKeys } from '@uplift/types';
import { BaseSuspenseQueryOpts } from '../baseTypes';


export const useAssessmentsKeysQuery = (opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'assessments-keys' ],
    queryFn: () => getAssessmentFormKeys(),
    ...opts,
  });
};


export const useAssessmentSubmissionsQuery = (patientId: string, assessmentKey?: AssessmentKeys, completedOnly?: boolean, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'form-submissions', patientId, assessmentKey ],
    queryFn: async () => {
      if (!assessmentKey) return null;

      const response = await getAllFormSubmissions({
        formKey: assessmentKey,
        patientId: patientId,
        completedOnly: completedOnly,
      });

      if ('error' in response) {
        throw new Error(response.error);
      }

      const submissions = response.submissions.map(submission => ({
        score: submission.score ?? 0,
        scoreDiffPercentage: submission.scoreDiffPercentage,
        submission: submission.submission,
      })) ?? [];

      submissions.sort((a, b) => CalendarDateService.compare(b.submission.createdAt, a.submission.createdAt));

      return submissions;
    },
    ...opts
  });
};


export const useRequestAdministeredSubmissionMutation = () => {
  return useMutation({
    mutationFn: async (args: RequestAdministeredSubmissionParams) => {
      return await requestAdministeredSubmission(args);
    },
  });
};
